export default __webpack_public_path__ + "static/media/mountain_inverse.b1132ec0.png";